// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"0c1a94f3","453":"ee671459"}[chunkId] + ".chunk.js";
};